<template>
  <div class="row" v-if="scheduleData">
    <div class="col_12">
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div class="form_row_inline">
                <label class="">Name</label>
                <div class="form_input">{{ scheduleData?.user?.name }}</div>
              </div>
              <div class="form_row_inline">
                <label class="">Date</label>
                <div class="form_input">{{ scheduleData?.work_date }}</div>
              </div>
              <div class="form_row_inline">
                <label class="">Time</label>
                <div class="form_input">
                  {{ scheduleData?.start_time }} - {{ scheduleData?.end_time }}
                </div>
              </div>
              <div
                :class="['form_row_inline', { has_error: errorFor('status') }]"
              >
                <label>Status</label>
                <div class="form_input">
                  <select class="form_global" v-model="form.status">
                    <option value="pending">Pending</option>
                    <option value="in_progress">In progress</option>
                    <option value="completed">Completed</option>
                  </select>
                  <v-errors :errors="errorFor('status')"></v-errors>
                </div>
              </div>
              <div class="form_row_inline">
                <label></label>
                <div class="form_input">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
            <div class="col_6 pr_20">
              <div class="form_row_inline">
                <label class="">Project name</label>
                <div class="form_input">{{ scheduleData?.project_title }}</div>
              </div>
              <div class="form_row_inline" v-if="scheduleData?.description">
                <label class="">Details</label>
                <div class="form_input">{{ scheduleData?.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'schedule-details',
  components: {},
  props: {
    scheduleData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      lyLoading: false,
      form: {
        status: this.scheduleData?.status,
      },
    };
  },
  created() {},
  methods: {
    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/schedules/' + this.scheduleData.id, formData)
        .then(() => {
          this.showSuccessMsg('Schedule Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
